import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? "AIzaSyDf1zOgYWPSgAWaAnyQKiVnx7Cqy2LsMS0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "veshjeperty-761f0.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "veshjeperty-761f0",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? "veshjeperty-761f0.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "25308178137",
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? "1:25308178137:web:ea5a64502ee6b9df0f00c8",
};

const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);

export default firebaseApp;
